import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Grid } from '@tq/ui-components';
import { useIsMobile } from '@tq/ui-components/dist/hooks';

import { useNavigate, useShowViewResponse } from 'hooks';
import { Consultation } from 'types';

export interface ArchivedConsultationButtonsProps {
  consultation: Consultation;
}

export const ArchivedConsultationButtons: React.FC<ArchivedConsultationButtonsProps> = ({
  consultation,
}) => {
  const { t } = useTranslation('summary_header');
  const { navigateToDetails, navigateToResponse } = useNavigate();
  const isMobile = useIsMobile();
  const showViewResponse = useShowViewResponse(consultation);

  return (
    <Grid
      data-testid='archived-consultation-buttons'
      gridAutoFlow='column'
      gridGap={4}
      w={isMobile ? '100%' : 'inherit'}
    >
      <Button
        minWidth='unset'
        variant='tertiary'
        onClick={() => consultation && navigateToDetails(consultation.id)}
      >
        {t('view_case_details', 'View case details')}
      </Button>
      {showViewResponse && (
        <Button
          minWidth='unset'
          variant='secondary'
          onClick={() => consultation && navigateToResponse(consultation.id)}
        >
          {t('view_response', 'View response')}
        </Button>
      )}
    </Grid>
  );
};
